<template>
    <nav
        v-if="visible"
        class="navbar navbar-expand-lg navbar-dark bg-primary mb-4"
    >
        <template v-if="company">
            <!-- Brand and toggle get grouped for better mobile display -->
            <a class="navbar-brand" :href="homeUrl">
                <img v-if="company.image" class="logo" :src="company.image" />
                <span v-if="!company.image" class="logo">
                    {{ company.name }}
                </span>
            </a>

            <!-- Collect the nav links, forms, and other content for toggling -->
            <div class="collapse navbar-collapse">
                <ul v-if="hasBoats" class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <router-link
                            class="nav-link"
                            :to="{ name: 'configurations' }"
                            >{{ $t("your_configurations") }}</router-link
                        >
                    </li>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" :href="company.website">
                            {{ $t("back_to_website", { name: company.name }) }}
                            <i class="fa fa-arrow-right"></i
                        ></a>
                    </li>
                </ul>
            </div>
        </template>
    </nav>
    <div v-else-if="!visible" class="mb-4"></div>
</template>

<script>
import CompanyMixin from "../mixins/Company.js";
export default {
    mixins: [CompanyMixin],
    mounted() {
        this.getCompany().then((response) => {
            this.company = response.data;
        });
    },
    data: function () {
        return {
            company: null,
        };
    },
    computed: {
        homeUrl: function () {
            return `/${this.company.slug}`;
        },
        visible: function () {
            return window.self === window.top;
        },
        hasBoats: function () {
            return true;
        },
    },
};
</script>
